"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FunctionBody = void 0;
const React = __importStar(require("react"));
const Field_UploadFile_1 = __importDefault(require("../child/Field.UploadFile"));
const FieldCheckBox_1 = __importDefault(require("../child/FieldCheckBox"));
const FieldDatePicker_1 = __importDefault(require("../child/FieldDatePicker"));
const FieldOTP_1 = __importDefault(require("../child/FieldOTP"));
const FieldPassword_1 = __importDefault(require("../child/FieldPassword"));
const FieldPhoneNumber_1 = __importDefault(require("../child/FieldPhoneNumber"));
const FieldRadio_1 = __importDefault(require("../child/FieldRadio"));
const FieldSelect_1 = __importDefault(require("../child/FieldSelect"));
const FieldText_1 = __importDefault(require("../child/FieldText"));
const FieldTextArea_1 = __importDefault(require("../child/FieldTextArea"));
const FieldTimePicker_1 = __importDefault(require("../child/FieldTimePicker"));
const type_1 = require("../../../type");
const Field_Constant_1 = require("./Field.Constant");
const FunctionBody = (props) => {
    if (props.type === type_1.TYPE_CUSTOMS) {
        return (React.createElement("div", { className: `${Field_Constant_1.TEXT_AUTHOR}-customs` }, props.fieldCustoms(props)));
    }
    else if ([type_1.TYPE_TEXT, type_1.TYPE_NUMBER, type_1.TYPE_EMAIL].includes(props.type)) {
        return React.createElement(FieldText_1.default, { props: props });
    }
    else if (props.type === type_1.TYPE_DATE) {
        return React.createElement(FieldDatePicker_1.default, { props: props });
    }
    else if (props.type === type_1.TYPE_TIME) {
        return React.createElement(FieldTimePicker_1.default, { props: props });
    }
    else if (props.type === type_1.TYPE_TEXT_AREA) {
        return React.createElement(FieldTextArea_1.default, { props: props });
    }
    else if (props.type === type_1.TYPE_RADIO) {
        return React.createElement(FieldRadio_1.default, { props: props });
    }
    else if (props.type === type_1.TYPE_SELECT) {
        return React.createElement(FieldSelect_1.default, { props: props });
    }
    else if (props.type === type_1.TYPE_CHECK_BOX) {
        return React.createElement(FieldCheckBox_1.default, { props: props });
    }
    else if (props.type === type_1.TYPE_FILE) {
        return React.createElement(Field_UploadFile_1.default, { props: props });
    }
    else if (props.type === type_1.TYPE_PASSWORD) {
        return React.createElement(FieldPassword_1.default, { props: props });
    }
    else if (props.type === type_1.TYPE_PHONE_NUMBER) {
        return React.createElement(FieldPhoneNumber_1.default, { props: props });
    }
    else if (props.type === type_1.TYPE_OTP) {
        return React.createElement(FieldOTP_1.default, { props: props });
    }
    else {
        return null;
    }
};
exports.FunctionBody = FunctionBody;
